<template>
  <div class="q-pa-md q-gutter-sm">
    <q-breadcrumbs>
      <q-breadcrumbs-el icon="home" to="/" />
      <q-breadcrumbs-el label="小程序设置" icon="widgets" to="/mp/config" />
    </q-breadcrumbs>
    <div class="row q-gutter-md justify-center">
      <div class="col-8" style="text-align: center">
        <h5>小程序设置</h5>
      </div>
      <div class="col-8">
        <q-input outlined v-model="config.appId" label="appId" :dense="dense">
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          v-model="config.secret"
          label="小程序秘钥"
          outlined
          :type="isPwd ? 'password' : 'text'"
          clearable
          :dense="dense"
        >
          <template v-slot:append>
            <q-icon
              :name="isPwd ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd = !isPwd"
            />
          </template>
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          outlined
          v-model="config.mchId"
          label="商户ID"
          :dense="dense"
          clearable
        >
        </q-input>
      </div>
      <div class="col-8">
        <q-input
          v-model="config.appKey"
          label="商户支付秘钥"
          outlined
          :type="isPwd1 ? 'password' : 'text'"
          clearable
          :dense="dense"
        >
          <template v-slot:append>
            <q-icon
              :name="isPwd1 ? 'visibility_off' : 'visibility'"
              class="cursor-pointer"
              @click="isPwd1 = !isPwd1"
            />
          </template>
        </q-input>
      </div>
      <div class="col-8 q-gutter-x-md" style="text-align: center">
        <q-btn label="保存" color="primary" @click="save" />
        <q-btn flat label="刷新" color="primary" @click="refreshAccessToken">
          <q-tooltip> 刷新accessToken </q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { get, save, refreshAccessToken } from "@/api/mp/config";
export default {
  data() {
    return {
      isPwd: true,
      isPwd1: true,
      dense: true,
      config: {},
    };
  },
  methods: {
    get: function () {
      let self = this;
      get().then((response) => {
        self.config = response.data.data;
      });
    },
    save: function () {
      save(this.config).then(() => {
        this.$q.notify({ type: "positive", message: "设置成功" });
      });
    },
    refreshAccessToken: function () {
      refreshAccessToken().then(() => {
        this.$q.notify({ type: "positive", message: "刷新成功" });
      });
    },
  },
  mounted: function () {
    this.get();
  },
};
</script>

<style scoped>
</style>